import {
  CDN_ASSETS_LINK_BASE,
  LYRA_SELECT_CDN_ASSETS_LINK_BASE,
  MICROSITE_CDN_ASSETS_LINK_BASE,
  NEURODIVERSITY_CDN_ASSETS_LINK_BASE,
} from '../constants'
import { BreakpointRangeKeys } from './breakpoints'

export interface BreakpointToAssetNameMap extends BreakpointRangeKeys<string> {
  defaultAsset: string
}

interface AssetConfig {
  assetNames: BreakpointToAssetNameMap
  /** Image should scale if width or height is greater than the specified value */
  shouldScale?: {
    minWidth?: number
    minHeight?: number
  }
}

export interface ThemeAssets {
  [key: string]: AssetConfig
}

export const baseAssets: ThemeAssets = {
  triageBackground: {
    assetNames: {
      defaultAsset: `${CDN_ASSETS_LINK_BASE}/triageBackgroundDesktop.jpg`,
      isMobileSized: 'triageBackgroundMobile',
    },
    shouldScale: {
      minWidth: 1990,
      minHeight: 1924,
    },
  },
  triageSummaryBackground: {
    assetNames: {
      defaultAsset: `${CDN_ASSETS_LINK_BASE}/triageBackgroundDesktop.jpg`,
      isMobileSized: 'triageBackgroundMobile',
    },
    shouldScale: {
      minWidth: 1990,
      minHeight: 1924,
    },
  },
  curvedHeader: {
    assetNames: {
      defaultAsset: 'CurvedHeaderDesktop',
      isMinWidthLaptop: 'CurvedHeaderLaptop',
      isMinWidthTablet: 'CurvedHeaderTablet',
      isMobileSized: 'CurvedHeaderMobile',
    },
  },
  meetWithAnExpert: {
    assetNames: {
      defaultAsset: `${MICROSITE_CDN_ASSETS_LINK_BASE}/MeetWithAnExpertLarge.png`,
      isMobileSized: `${MICROSITE_CDN_ASSETS_LINK_BASE}/MeetWithAnExpert.png`,
    },
  },
  cloudBackground: {
    assetNames: {
      defaultAsset: `${MICROSITE_CDN_ASSETS_LINK_BASE}/LyraSelectFooterMobilePlus.png`,
      isMinWidthDesktopL: `${MICROSITE_CDN_ASSETS_LINK_BASE}/LyraSelectCloudsStarsBackgroundDesktopPlus.png`,
      isMinWidthDesktop: `${MICROSITE_CDN_ASSETS_LINK_BASE}/LyraSelectCloudsStarsBackgroundDesktop.png`,
      isMinWidthLaptop: `${MICROSITE_CDN_ASSETS_LINK_BASE}/LyraSelectCloudsStarsBackgroundLaptop.png`,
      isMinWidthTablet: `${MICROSITE_CDN_ASSETS_LINK_BASE}/LyraSelectFooterTablet.png`,
      isMinWidthMobileL: `${MICROSITE_CDN_ASSETS_LINK_BASE}/LyraSelectFooterMobilePlus.png`,
      isMobileSized: `${MICROSITE_CDN_ASSETS_LINK_BASE}/LyraSelectFooterMobile.png`,
    },
  },
  wellnessToolkitHeader: {
    assetNames: {
      defaultAsset: 'WellnessToolkitHeaderImage',
      isMobileSized: 'WellnessToolkitMobileHeaderImage',
    },
  },
  mobileSliderThumb: {
    assetNames: {
      defaultAsset: 'sliderThumb',
    },
  },
  wellnessCheckInBackground: {
    assetNames: {
      defaultAsset: `${CDN_ASSETS_LINK_BASE}/WellnessCheckInBackgroundDesktop.png`,
      isMinWidthTablet: `${CDN_ASSETS_LINK_BASE}/WellnessCheckInBackgroundTablet.png`,
      isMinWidthLaptop: `${CDN_ASSETS_LINK_BASE}/WellnessCheckInBackgroundDesktop.png`,
      isMobileSized: `${CDN_ASSETS_LINK_BASE}/WellnessCheckInBackgroundMobile.png`,
    },
  },
  wellnessCheckInResultsHeader: {
    assetNames: {
      defaultAsset: 'WellnessCheckInResultsHeader',
      isMinWidthTablet: 'WellnessCheckInResultsHeaderTablet',
      isMinWidthLaptop: 'WellnessCheckInResultsHeader',
      isMobileSized: 'WellnessCheckInResultsHeaderMobile',
      isMinWidthMobileL: 'WellnessCheckInResultsHeaderMobilePlus',
    },
  },
  neurodiversityEntrypointBannerAdult: {
    assetNames: {
      defaultAsset: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/EntrypointBannerAdult.png`,
      isMobileSized: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/EntrypointBannerAdultMobile.png`,
    },
  },
  neurodiversityEntrypointBannerTeen: {
    assetNames: {
      defaultAsset: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/EntrypointBannerTeen.png`,
      isMobileSized: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/EntrypointBannerTeenMobile.png`,
    },
  },
  neurodiversitySupportSectionAdult: {
    assetNames: {
      defaultAsset: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/toolkit-page-care-options-adult.png`,
    },
  },
  neurodiversitySupportSectionAdultPlusChild: {
    assetNames: {
      defaultAsset: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/toolkit-page-care-options-adult.png`,
    },
  },
  neurodiversitySupportSectionChild: {
    assetNames: {
      defaultAsset: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/toolkit-page-care-options-child-tablet-mobile.png`,
      isMinWidthLaptop: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/toolkit-page-care-options-child.png`,
    },
  },
  neurodiversitySupportSectionTeen: {
    assetNames: {
      defaultAsset: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/toolkit-page-care-options-teen.png`,
    },
  },
  neurodiversityGetInTouchSectionAdult: {
    assetNames: {
      defaultAsset: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/chat-about-options-tablet-mobile-adult.png`,
      isMinWidthLaptop: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/chat-about-options-laptop-adult.png`,
      isMinWidthDesktop: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/chat-about-options-adult.png`,
    },
  },
  neurodiversityGetInTouchSectionTeen: {
    assetNames: {
      defaultAsset: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/chat-about-options-tablet-mobile-teen.png`,
      isMinWidthLaptop: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/chat-about-options-laptop-teen.png`,
      isMinWidthDesktop: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/chat-about-options-teen.png`,
    },
  },
  neurodiversityToolkitAdultPlusChildHeader: {
    assetNames: {
      defaultAsset: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-adult-with-child-light-tablet.png`,
      isMinWidthDesktopL: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-adult-with-child-light-desktopL.png`,
      isMinWidthDesktop: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-adult-with-child-light-desktop.png`,
      isMinWidthTablet: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-adult-with-child-light-tablet.png`,
      isMobileSized: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/toolkit-page-header-adult-with-child-mobile.png`,
    },
  },
  neurodiversityToolkitAdultOnlyHeader: {
    assetNames: {
      defaultAsset: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-adult-light-tablet.png`,
      isMinWidthDesktopL: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-adult-light-desktopL.png`,
      isMinWidthDesktop: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-adult-light-desktop.png`,
      isMinWidthTablet: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-adult-light-tablet.png`,
      isMobileSized: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/toolkit-page-header-adult-mobile.png`,
    },
  },
  neurodiversityToolkitTeenHeader: {
    assetNames: {
      defaultAsset: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-teen-light-tablet.png`,
      isMinWidthDesktopL: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-teen-light-desktopL.png`,
      isMinWidthDesktop: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-teen-light-desktop.png`,
      isMinWidthTablet: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-teen-light-tablet.png`,
      isMobileSized: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/toolkit-page-header-teen-mobile.png`,
    },
  },
  healthChallengesToolkitHeader: {
    assetNames: {
      defaultAsset: `${CDN_ASSETS_LINK_BASE}/healthchallenges/HeaderImage-Light-Tablet.png`,
      isMinWidthDesktopL: `${CDN_ASSETS_LINK_BASE}/healthchallenges/HeaderImage-Light-Desktop.png`,
      isMinWidthDesktop: `${CDN_ASSETS_LINK_BASE}/healthchallenges/HeaderImage-Light-Laptop.png`,
      isMinWidthTablet: `${CDN_ASSETS_LINK_BASE}/healthchallenges/HeaderImage-Light-Tablet.png`,
      isMobileSized: `${CDN_ASSETS_LINK_BASE}/healthchallenges/HeaderImage-Light-Mobile.png`,
    },
  },
  womensHealthToolkitHeader: {
    assetNames: {
      defaultAsset: `${CDN_ASSETS_LINK_BASE}/womenshealth/HeaderImage-Light-Tablet.png`,
      isMinWidthDesktopL: `${CDN_ASSETS_LINK_BASE}/womenshealth/HeaderImage-Light-Desktop.png`,
      isMinWidthDesktop: `${CDN_ASSETS_LINK_BASE}/womenshealth/HeaderImage-Light-Laptop.png`,
      isMinWidthTablet: `${CDN_ASSETS_LINK_BASE}/womenshealth/HeaderImage-Light-Tablet.png`,
      isMobileSized: `${CDN_ASSETS_LINK_BASE}/womenshealth/HeaderImage-Light-Mobile.png`,
    },
  },
  careNavigatorEntryPoint: {
    assetNames: {
      defaultAsset: `${CDN_ASSETS_LINK_BASE}/CareNavigatorGeneralEntryPointImage.png`,
      isMinWidthLaptop: `${CDN_ASSETS_LINK_BASE}/CareNavigatorGeneralEntryPointImageDesktop.png`,
    },
  },
}

export const darkModeBaseAssets: ThemeAssets = {
  ...baseAssets,
  neurodiversitySupportSectionAdult: {
    assetNames: {
      defaultAsset: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/toolkit-page-care-options-adult-dark.png`,
    },
  },
  neurodiversitySupportSectionAdultPlusChild: {
    assetNames: {
      defaultAsset: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/toolkit-page-care-options-adult-dark.png`,
    },
  },
  neurodiversitySupportSectionChild: {
    assetNames: {
      defaultAsset: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/toolkit-page-care-options-child-tablet-mobile-dark.png`,
      isMinWidthLaptop: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/toolkit-page-care-options-child-dark.png`,
    },
  },
  neurodiversitySupportSectionTeen: {
    assetNames: {
      defaultAsset: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/toolkit-page-care-options-teen-dark.png`,
    },
  },
  neurodiversityGetInTouchSectionAdult: {
    assetNames: {
      ...baseAssets.neurodiversityGetInTouchSectionAdult.assetNames,
      defaultAsset: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/chat-about-options-tablet-mobile-adult-dark.png`,
    },
  },
  neurodiversityGetInTouchSectionTeen: {
    assetNames: {
      ...baseAssets.neurodiversityGetInTouchSectionTeen.assetNames,
      defaultAsset: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/chat-about-options-tablet-mobile-teen-dark.png`,
    },
  },
  neurodiversityToolkitAdultPlusChildHeader: {
    assetNames: {
      defaultAsset: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-adult-with-child-dark-tablet.png`,
      isMinWidthDesktopL: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-adult-with-child-dark-desktopL.png`,
      isMinWidthDesktop: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-adult-with-child-dark-desktop.png`,
      isMinWidthTablet: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-adult-with-child-dark-tablet.png`,
      isMobileSized: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/NeurodiversityToolkitAdultChildPeopleIllustrationDark.png`,
    },
  },
  neurodiversityToolkitAdultOnlyHeader: {
    assetNames: {
      defaultAsset: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-adult-dark-tablet.png`,
      isMinWidthDesktopL: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-adult-dark-desktopL.png`,
      isMinWidthDesktop: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-adult-dark-desktop.png`,
      isMinWidthTablet: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-adult-dark-tablet.png`,
      isMobileSized: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/toolkit-page-header-adults-mobile-dark.png`,
    },
  },
  neurodiversityToolkitTeenHeader: {
    assetNames: {
      defaultAsset: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-teen-dark-tablet.png`,
      isMinWidthDesktopL: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-teen-dark-desktopL.png`,
      isMinWidthDesktop: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-teen-dark-desktop.png`,
      isMinWidthTablet: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/header-teen-dark-tablet.png`,
      isMobileSized: `${NEURODIVERSITY_CDN_ASSETS_LINK_BASE}/NeurodiversityToolkitTeenPeopleIllustrationDark.png`,
    },
  },
  healthChallengesToolkitHeader: {
    assetNames: {
      defaultAsset: `${CDN_ASSETS_LINK_BASE}/healthchallenges/HeaderImage-Dark-Tablet.png`,
      isMinWidthDesktopL: `${CDN_ASSETS_LINK_BASE}/healthchallenges/HeaderImage-Dark-Desktop.png`,
      isMinWidthDesktop: `${CDN_ASSETS_LINK_BASE}/healthchallenges/HeaderImage-Dark-Laptop.png`,
      isMinWidthTablet: `${CDN_ASSETS_LINK_BASE}/healthchallenges/HeaderImage-Dark-Tablet.png`,
      isMobileSized: `${CDN_ASSETS_LINK_BASE}/healthchallenges/HeaderImage-Dark-Mobile.png`,
    },
  },
  womensHealthToolkitHeader: {
    assetNames: {
      defaultAsset: `${CDN_ASSETS_LINK_BASE}/womenshealth/HeaderImage-Dark-Tablet.png`,
      isMinWidthDesktopL: `${CDN_ASSETS_LINK_BASE}/womenshealth/HeaderImage-Dark-Desktop.png`,
      isMinWidthDesktop: `${CDN_ASSETS_LINK_BASE}/womenshealth/HeaderImage-Dark-Laptop.png`,
      isMinWidthTablet: `${CDN_ASSETS_LINK_BASE}/womenshealth/HeaderImage-Dark-Tablet.png`,
      isMobileSized: `${CDN_ASSETS_LINK_BASE}/womenshealth/HeaderImage-Dark-Mobile.png`,
    },
  },
}

export const selectAssets: ThemeAssets = {
  ...baseAssets,
  triageBackground: {
    assetNames: {
      defaultAsset: `${LYRA_SELECT_CDN_ASSETS_LINK_BASE}/triage/sky-gradient-mobile.png`,
      isMinWidthDesktopL: `${LYRA_SELECT_CDN_ASSETS_LINK_BASE}/triage/sky-gradient-desktop-plus.png`,
      isMinWidthLaptop: `${LYRA_SELECT_CDN_ASSETS_LINK_BASE}/triage/sky-gradient-desktop.png`,
      isMinWidthTablet: `${LYRA_SELECT_CDN_ASSETS_LINK_BASE}/triage/sky-gradient-tablet.png`,
      isMinWidthMobileS: `${LYRA_SELECT_CDN_ASSETS_LINK_BASE}/triage/sky-gradient-mobile-large.png`,
    },
  },
  triageSummaryBackground: {
    assetNames: {
      defaultAsset: `${LYRA_SELECT_CDN_ASSETS_LINK_BASE}/triage/sky-cloud-mobile.png`,
      isMinWidthDesktopL: `${LYRA_SELECT_CDN_ASSETS_LINK_BASE}/triage/sky-cloud-desktop-plus.png`,
      isMinWidthLaptop: `${LYRA_SELECT_CDN_ASSETS_LINK_BASE}/triage/sky-cloud-desktop.png`,
      isMinWidthTablet: `${LYRA_SELECT_CDN_ASSETS_LINK_BASE}/triage/sky-cloud-tablet.png`,
      isMinWidthMobileS: `${LYRA_SELECT_CDN_ASSETS_LINK_BASE}/triage/sky-cloud-mobile-large.png`,
    },
  },
  curvedHeader: {
    assetNames: {
      defaultAsset: 'CurvedHeaderMobile',
      isMinWidthDesktopL: 'CurvedHeaderDesktopPlus',
      isMinWidthLaptop: 'CurvedHeaderDesktop',
      isMinWidthTablet: 'CurvedHeaderLaptop',
      isMinWidthMobileS: 'CurvedHeaderTablet',
    },
  },
  wellnessToolkitHeader: {
    assetNames: {
      defaultAsset: 'WellnessToolkitHeaderLyraSelectImage',
      isMobileSized: 'WellnessToolkitMobileHeaderLyraSelectImage',
    },
  },
  mobileSliderThumb: {
    assetNames: {
      defaultAsset: 'lyraSelectSliderThumb',
    },
  },
}

export const selectDarkModeAssets: ThemeAssets = {
  ...selectAssets,
  triageBackground: {
    assetNames: {
      defaultAsset: `${LYRA_SELECT_CDN_ASSETS_LINK_BASE}/triage/sky-gradient-mobile-dark.png`,
      isMinWidthMobileL: `${LYRA_SELECT_CDN_ASSETS_LINK_BASE}/triage/sky-gradient-mobile-large-dark.png`,
    },
  },
  triageSummaryBackground: {
    assetNames: {
      defaultAsset: `${LYRA_SELECT_CDN_ASSETS_LINK_BASE}/triage/sky-cloud-mobile-dark.png`,
      isMinWidthMobileL: `${LYRA_SELECT_CDN_ASSETS_LINK_BASE}/triage/sky-cloud-mobile-large-dark.png`,
    },
  },
  curvedHeader: {
    assetNames: {
      defaultAsset: `${CDN_ASSETS_LINK_BASE}/SelectDarkModeCurvedHeaderMobileLarge.png`,
      isMinWidthMobileXxs: `${CDN_ASSETS_LINK_BASE}/SelectDarkModeCurvedHeaderMobile.png`,
      isMinWidthMobileL: `${CDN_ASSETS_LINK_BASE}/SelectDarkModeCurvedHeaderMobileLarge.png`,
    },
  },
  cloudBackground: {
    assetNames: {
      defaultAsset: `${CDN_ASSETS_LINK_BASE}/LyraSelectCloudsStarsDarkModeBGMobilePlus.png`,
      isMinWidthMobileXxs: `${CDN_ASSETS_LINK_BASE}/LyraSelectCloudsStarsDarkModeBGMobile.png`,
      isMinWidthMobileL: `${CDN_ASSETS_LINK_BASE}/LyraSelectCloudsStarsDarkModeBGMobilePlus.png`,
    },
  },
  wellnessToolkitHeader: {
    assetNames: {
      defaultAsset: `${CDN_ASSETS_LINK_BASE}/WellnessToolkitMobileDarkModeHeaderImage.png`,
      isMobileSized: `${CDN_ASSETS_LINK_BASE}/WellnessToolkitMobileDarkModeHeaderImage.png`,
    },
  },
  mobileSliderThumb: {
    assetNames: {
      defaultAsset: 'lyraSelectDarkModeSliderThumb',
    },
  },
  wellnessCheckInBackground: {
    assetNames: {
      defaultAsset: `${CDN_ASSETS_LINK_BASE}/WellnessCheckInSelectDarkModeBackgroundDesktop.png`,
      isMinWidthTablet: `${CDN_ASSETS_LINK_BASE}/WellnessCheckInSelectDarkModeBackgroundTablet.png`,
      isMinWidthLaptop: `${CDN_ASSETS_LINK_BASE}/WellnessCheckInSelectDarkModeBackgroundDesktop.png`,
      isMobileSized: `${CDN_ASSETS_LINK_BASE}/WellnessCheckInSelectDarkModeBackgroundMobile.png`,
    },
  },
  wellnessCheckInResultsHeader: {
    assetNames: {
      defaultAsset: `${CDN_ASSETS_LINK_BASE}/WellnessCheckInResultsHeaderDesktopSelectDarkMode.png`,
      isMinWidthTablet: `${CDN_ASSETS_LINK_BASE}/WellnessCheckInResultsHeaderTabletSelectDarkMode.png`,
      isMinWidthLaptop: `${CDN_ASSETS_LINK_BASE}/WellnessCheckInResultsHeaderDesktopSelectDarkMode.png`,
      isMobileSized: `${CDN_ASSETS_LINK_BASE}/WellnessCheckInResultsHeaderMobileSelectDarkMode.png`,
      isMinWidthMobileL: `${CDN_ASSETS_LINK_BASE}/WellnessCheckInResultsMobilePlusSelectDarkMode.png`,
    },
  },
}
